var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SoliForm", {
        ref: "updateStudents",
        attrs: {
          title: "Manage Enrollment",
          saveChanges: _vm.enrollmentLoading,
          text: "Save",
        },
        on: {
          submit: _vm.submitUpdateStudents,
          reset: function ($event) {
            return _vm.$emit("reset")
          },
          "hook:mounted": _vm.loadStudentLists,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                (_vm.event.group_event.recurring &&
                  _vm.event.type == "Event") ||
                _vm.event.event_register_id
                  ? _c("SoliStudents", {
                      ref: "enrolled",
                      attrs: {
                        multiple: "",
                        chips: "",
                        dense: false,
                        label: "Enrolled Students",
                        deletableChips: "",
                        closeOnClick: "",
                        smallChips: "",
                        autocomplete: true,
                        enrolled: _vm.enrolledStudents,
                        filter: _vm.guestStudents,
                        lessonType: _vm.event.group_event?.access ?? null,
                        onDemand: "",
                        groupEventId: _vm.event.group_event?.id,
                      },
                      on: {
                        loaded: function ($event) {
                          _vm.enrolledLoaded = true
                        },
                        "hook:mounted": function ($event) {
                          _vm.enrolledLoaded = false
                        },
                        select: function ($event) {
                          return _vm.handleSelectEnrolled($event)
                        },
                      },
                      model: {
                        value: _vm.updateStudents,
                        callback: function ($$v) {
                          _vm.updateStudents = $$v
                        },
                        expression: "updateStudents",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.event.event_register_id
                  ? _c("SoliStudents", {
                      ref: "guests",
                      attrs: {
                        multiple: "",
                        label: "Guests",
                        chips: "",
                        deletableChips: "",
                        closeOnClick: "",
                        smallChips: "",
                        dense: false,
                        autocomplete: true,
                        guests: _vm.guestStudents,
                        filter: _vm.enrolledStudents,
                        guestPasses: "",
                        lessonType: _vm.event.group_event?.access ?? null,
                        onDemand: "",
                        groupEventId: _vm.event.group_event?.id,
                      },
                      on: {
                        loaded: function ($event) {
                          _vm.guestsLoaded = true
                        },
                        "hook:mounted": function ($event) {
                          _vm.guestsLoaded = false
                        },
                        select: function ($event) {
                          return _vm.handleSelectGuest($event)
                        },
                        remove: function ($event) {
                          return _vm.handleRemoveGuest($event)
                        },
                      },
                      model: {
                        value: _vm.updateGuests,
                        callback: function ($$v) {
                          _vm.updateGuests = $$v
                        },
                        expression: "updateGuests",
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.showCapacityWarning
        ? _c(
            "SoliChoice",
            {
              attrs: {
                title: "Hold up",
                subtitle: `This class has reached capacity on the following dates. Student(s) have not been enrolled${
                  _vm
                    .moment(_vm.showCapacityWarning[0])
                    .isSame(_vm.moment(_vm.event.starts_at), "day")
                    ? " or added as guests."
                    : ", but any guests and first visit students have been added successfully."
                }`,
                button1: "Okay",
                permanent: "",
              },
              on: {
                reset: function ($event) {
                  _vm.showCapacityWarning = null
                },
                option1: function ($event) {
                  ;[
                    (_vm.$refs.updateStudents.dialog = false),
                    _vm.$emit("success"),
                    (_vm.$page.props.successMessage =
                      "Error adding students to class"),
                  ]
                },
              },
            },
            [
              [
                _c(
                  "v-list",
                  { attrs: { dense: "" } },
                  _vm._l(_vm.showCapacityWarning, function (conflict) {
                    return _c("v-list-item", { key: conflict }, [
                      _c("small", { staticClass: "soli-grey" }, [
                        _vm._v(_vm._s(`${_vm.globalMomentDate(conflict)}`)),
                      ]),
                    ])
                  }),
                  1
                ),
              ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showNoAvailableOptionAlert
        ? _c("SoliChoice", {
            attrs: {
              title: "Uh oh",
              subtitle: `${_vm.selectedStudent?.name} does not have an available purchase option for this class.`,
              button1: "Visit Store",
              button2: "Nevermind",
              permanent: "",
            },
            on: {
              reset: function ($event) {
                _vm.showNoAvailableOptionAlert = false
              },
              option1: function ($event) {
                return _vm.visitStore()
              },
              option2: function ($event) {
                return _vm.cancelAddToClass()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showFirstVisitAlert
        ? _c(
            "SoliChoice",
            {
              attrs: {
                title: "First Visit?",
                subtitle: `Is this ${_vm.selectedStudent?.name}'s first visit to ${this.event.group_event.title}? Adding them to this class will send an automated welcome email.`,
                button1: "Yep!",
                button2: "No",
                disabled1: !_vm.billingUser,
                permanent: "",
              },
              on: {
                reset: function ($event) {
                  _vm.showFirstVisitAlert = false
                },
                option1: function ($event) {
                  return _vm.confirmFirstVisit()
                },
                option2: function ($event) {
                  return _vm.cancelFirstVisit()
                },
              },
            },
            [
              [
                _c("v-select", {
                  staticClass: "soli-grey pa-2",
                  attrs: {
                    solo: "",
                    outlined: "",
                    dense: "",
                    "hide-details": "",
                    "return-object": "",
                    flat: "",
                    "item-text": "name",
                    "item-value": "id",
                    label: "Billing User",
                    items: _vm.relationshipsAndMe,
                  },
                  model: {
                    value: _vm.billingUser,
                    callback: function ($$v) {
                      _vm.billingUser = $$v
                    },
                    expression: "billingUser",
                  },
                }),
              ],
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }